<script>
    import { MapStore } from './map-store'
    import { uuid as UUID } from './uuid'
    import {getContext, createEventDispatcher } from 'svelte'

    let activeNotebook = getContext('Section.activeNotebookStore') || new MapStore();
    let activeNotebookStore = activeNotebook.store

    export let uuid = UUID();
    export let showTitle = false;
    export let title = null;
    export let notebookViews;
    export let extraClass = undefined;
    export let activeViewIdx = $activeNotebookStore.get(uuid) || 0;

    const dispatch = createEventDispatcher();

    function updateActiveView(i) {
        activeNotebook.set(uuid, i);

        activeViewIdx = i;

        dispatch('changeActiveView', {
            view: notebookViews[i],
            idx: i
        });
    }

    $: activeView = notebookViews[activeViewIdx] || notebookViews[0];

    $: {
        console.log(`${title} ${uuid} ${activeViewIdx}`);
    }
</script>

<style>
    .section {
        padding: 0 1em;
    }

    .section-header {
        display: flex;
        flex-wrap: wrap;
    }

    .section-title {
        flex: 1;
        margin-left: 2.5em;
        font-weight: bolder;
    }

    @media print {
        .section {
            padding: 0;
        }

        .section-header {
            page-break-after: avoid;
            break-after: avoid;
            break-before: auto;
            page-break-before: auto;
        }

        :global(.section-title ~ *) {
            page-break-before: avoid;
            break-before: avoid;
        }

        .view-button {
            display: none !important;
        }
    }

    .view-button {
        font-weight: bold;
        margin-left: 0.5em;
    }
</style>

<div class="section {extraClass || ''}">
    <div class="section-header">
        {#if showTitle && title}
            <h4 class="section-title">{title}</h4>
        {:else}
            <span class="section-title"></span>
        {/if}
        {#if notebookViews && notebookViews.length > 1 }
            <span class="view-buttons">
                {#each notebookViews as view, i (view.id || view.uuid || view)}
                    <button class="view-button flat"
                          class:flat-inactive={i !== activeViewIdx}
                          class:flat-primary={i === activeViewIdx}
                          class:underline={i === activeViewIdx}
                          on:click={() => updateActiveView(i)}>
                        { view.title || `view ${i}` }
                    </button>
                {/each}
            </span>
        {/if}
    </div>

    <slot activeView={activeView}></slot>
</div>

